import { Link } from 'react-router-dom';

interface MangaCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  chapters: number;
  rating: number;
  latestChapter: string;
  status: string;
  category?: string;
}

export default function MangaCard({
  id,
  title,
  author,
  cover,
  chapters,
  rating,
  latestChapter,
  status,
}: MangaCardProps) {
  return (
    <Link
      to={`/manga/${id}/chapter/${chapters}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={title}
          title={`${title} - 4399漫画网免费下拉式阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
        <div className="absolute top-2 left-2">
          <span
            className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${
              status === '连载中'
                ? 'bg-primary-500 text-white'
                : 'bg-foreground-600 text-white'
            }`}
          >
            {status}
          </span>
        </div>
        <div className="absolute bottom-2 left-2 right-2">
          <p className="text-xs text-white/80 truncate">{latestChapter}</p>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
        {title}
      </h3>
      <div className="flex items-center justify-between mt-1">
        <p className="text-xs text-foreground-400 truncate">{author}</p>
        <div className="flex items-center gap-0.5 whitespace-nowrap">
          <i className="ri-star-fill text-amber-400 text-[10px]"></i>
          <span className="text-xs text-foreground-500 font-medium">{rating}</span>
        </div>
      </div>
    </Link>
  );
}